import _ from 'lodash'
import defaultState from '@/store/modules/quickAction/state'
import types from './types'
import mutationsHelpers from '@/store/modules/rev/mutationsHelpers.js'

function deserializeTeam(team) {
  return {
    owner: team.owner ? mutationsHelpers.formatOwner(team.owner) : {},
    coach: team.coach ? mutationsHelpers.formatCoach(team.coach) : {},
    collaborators: _.get(team, 'collaborators', []).map(
      mutationsHelpers.formatUser
    ),
  }
}

export default {
  [types.SET_REV](state, payload) {
    let rev = defaultState.rev
    rev = Object.assign(rev, _.get(payload, 'rev', payload))
    const team = _.get(rev, 'team', {})
    state.rev = {
      ...rev,
      team: deserializeTeam(team),
      completedBy: rev.completedBy
        ? mutationsHelpers.formatUser(rev.completedBy)
        : {},
      onHoldReason: rev?.onHoldReason || null,
      onHoldBy: rev?.onHoldBy || null,
      onHoldAt: rev?.onHoldAt || null,
      canceledReason: rev?.canceledReason || null,
      canceledBy: rev?.canceledBy || null,
      canceledAt: rev?.canceledAt || null,
      approvals: rev?.approvals || null,
      approvedByMe: rev?.approvedByMe || null,
      isApproved: rev.isApproved || null,
      predictedFinancialImpactInUSD: rev?.predictedFinancialImpactInUSD ?? null,
    }
  },

  [types.SET_AVAILABLE_OWNERS](state, { results }) {
    state.availableOwners = results.map(mutationsHelpers.formatUser)
  },

  [types.SET_AVAILABLE_COACHES](state, { results }) {
    state.availableCoaches = results.map(mutationsHelpers.formatCoach)
  },

  [types.SET_AVAILABLE_COLLABORATORS](state, { results }) {
    state.availableCollaborators = results.map(mutationsHelpers.formatUser)
  },

  [types.SET_CHALLENGES](state, challenges) {
    state.challenges = challenges
  },

  resetRev(state, rev) {
    state.rev = rev || _.cloneDeep(defaultState.rev)
  },

  updateRevName(state, name) {
    state.rev.name = name
  },
  setOwner(state, owner) {
    state.rev.team.owner = owner
  },
  setCoach(state, coach) {
    state.rev.team.coach = coach
  },

  setCollaborators(state, collaborators) {
    state.rev.team.collaborators = collaborators
  },

  updateLocation(state, location) {
    state.rev = {
      ...state.rev,
      location: {
        organization: location.organization,
        site: location.site,
        tags: location.tags || [],
      },
    }
  },

  updateSituation(state, situation) {
    state.rev = {
      ...state.rev,
      beforePhase: {
        ..._.get(state, 'rev.beforePhase', {}),
        situation,
      },
    }
  },

  updateSituationMedia(state, situationMedia) {
    state.rev = {
      ...state.rev,
      beforePhase: {
        ..._.get(state, 'rev.beforePhase', {}),
        media: situationMedia,
      },
    }
  },

  updateSituationTypes(state, situationTypes) {
    state.rev = {
      ...state.rev,
      beforePhase: {
        ..._.get(state, 'rev.beforePhase', {}),
        situationTypes,
      },
    }
  },

  updateSolution(state, solution) {
    state.rev = {
      ...state.rev,
      afterPhase: {
        ..._.get(state, 'rev.afterPhase', {}),
        solution,
      },
    }
  },

  updateSolutionMedia(state, solutionMedia) {
    state.rev = {
      ...state.rev,
      afterPhase: {
        ..._.get(state, 'rev.afterPhase', {}),
        media: solutionMedia,
      },
    }
  },

  updateSuggestedTags(state, suggestedTags) {
    state.rev = {
      ...state.rev,
      afterPhase: {
        ..._.get(state, 'rev.afterPhase', {}),
        suggestedTags,
      },
    }
  },

  updateCompletedAuthor(state, user) {
    state.rev = {
      ...state.rev,
      completedBy: user,
    }
  },

  updateImpactMetrics(state, metrics) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        impacts: metrics,
      },
    }
  },

  updateInvestments(state, investments) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        investments: investments,
      },
    }
  },

  updateStartDate(state, date) {
    state.rev.impactStartsAt = date
  },

  updateEndDate(state, date) {
    state.rev.impactEndsAt = date
  },

  updateCostReduction(state, costReduction) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        costReduction: {
          capturedValue: costReduction,
        },
      },
    }
  },

  updateInvestment(state, investment) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        investment: {
          capturedValue: investment,
        },
      },
    }
  },

  updateTimeInvested(state, timeInvested) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        timeTracking: {
          ...state.rev.reviewPhase.timeTracking,
          timeInvested,
        },
      },
    }
  },

  updateTimeReductionByMonth(state, timeReductionByMonth) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        timeTracking: {
          ...state.rev.reviewPhase.timeTracking,
          timeReductionByMonth,
        },
      },
    }
  },

  updateEstimationExplanation(state, estimationExplanation) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        estimationExplanation,
      },
    }
  },

  updateCategories(state, categories) {
    state.rev = {
      ...state.rev,
      categories,
    }
  },

  updatePriority(state, priority) {
    state.rev.priority = priority
  },

  updateDueDate(state, date) {
    state.rev.dueDate = date
  },

  updateNotes(state, notes) {
    state.rev.notes = notes
  },
}
